
// import SideBar from "./SideBar";
// import { useState,useEffect ,useContext} from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome,faClipboard,faChartLine,faTools,faUser,faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { setISODay } from "date-fns";
import { it } from "date-fns/locale";
import { useState,useEffect ,useContext} from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { axiosPrivate } from "../../api/axios";


import useAuth from "../../Hooks/UseAuth";
import AuthContext from "../../Context/AuthProvider";

import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import "./EditUser.css"



function EditUser(){  

      



        /////////
        const axiosPrivate = useAxiosPrivate();
        // const auth = useAuth();
        const { setAuth,auth } = useContext(AuthContext);
        const [email, setEmail] = useState('');
        const [name, setName] = useState('')
        const [password, setPassword] = useState(''); 
        // const {setAuth, auth} = useAuth()
        const [signUp, setSignup] = useState(false); 
        const [loginState, setLogin] = useState(true); 
        const [register, setRegister] = useState(false);
        const [Branch, setBranch] = useState("");
        const [AccNo, setAccNo] = useState("");
        const [Loading, setLoading] = useState(false);
        const [errorMsg, setErrorMsg] = useState(false);
        const [Msg, setMsg] = useState("");
        const [successMsg, setSuccessMsg] = useState(false);
        const [Gender, setGender] = useState("");
        const [Ssn, setSsn] = useState("");
        const [Compensation, setCompensation] = useState("");
        // const [position, setPosition] = useState("");
        const [mgtLvl, setMgtLevl] = useState("");
        const [address, setAddress] = useState("");
        // const [Compensation, setCompensation] = useState("");
        const[tData, setTData] = useState([]);
        const [searchData, setSearchData] = useState(""); 
        const [fildata, setFildata] = useState([]); 
        const [userData, setUserData] = useState([]); 
        const [users, setUsers] = useState([]);
      
        const [doh, setDoh] = useState("");
        const [UID, setUID] = useState("");
        const [FInstitution, setFInstitutionn] = useState("");
        // const [Compensation, setCompensation] = useState("");
        const [nik, setNik] = useState("");
      
        
        const [nikRel, setNikRel] = useState("");
        const [nikAddress, setNikAddress] = useState("");
        const [nikContact, setNikContact] = useState("");
        const [position, setPosition] = useState("");
        const [AccountType, setAccountType] = useState("");
        const [AccountBranch, setAccountBranch] = useState("");
        const [status, setStatus] = useState("");
        const [ID, setID] = useState("");
        const [tidType,setType] = useState(); 
        const options = ["Active","Inactive"];
        const optionstwo = ["Male","Female"];
        const [dropState,setDropState] =useState(false); 
        const [dropStateTwo,setDropStateTwo] =useState(false); 
        const [selected,setSelected] = useState("Select Work Status"); 
        const [selectedtwo,setSelectedtwo] = useState("Select Gender"); 
      

          // const[tData, setTData] = useState([]);
          

              //Register user function
              async function registerUser(e) {  
                e.preventDefault(); 
                setLoading(true);
                setSuccessMsg(false);
                setErrorMsg(false);

             
                // const response = await fetch("http://localhost:2001/api/userEdit",{ 
                 const response = await fetch("https://nerdayb.onrender.com/api/userEdit",{ 
                        method : "POST",
                        headers: { 
                         "content-type" :   "application/json"
                        }, 
                        body: JSON.stringify({
                            name,
                            email,
                            Gender,
                            AccNo,
                            Compensation,
                            Ssn,
                            mgtLvl,
                            position,
                            address,
                            position,
                            // doh,
                            FInstitution,
                            AccountBranch,
                            AccountType,
                            nik,
                            address,
                            nikAddress,
                            address,
                            nikContact,
                            nikRel,
                            ID,
                            status

                            
                        })
                        
        
                 }) 
        
                 const data = await response.json();
                 console.log(data);
        
              
        
                  if(data.status == 'Ok'){
                    // navigate("/login");

                    setPosition("");
                    setAccNo("");
                    setGender("");
                    setMgtLevl("");
                    setAddress("");
                    setCompensation("");
                    setLoading(false);
                    setEmail("");
                    setEmail("");
                    setSsn("");
                    setName("");
                    setAccNo("");
                    setAccountBranch("");
                    setAddress("");
                    setFInstitutionn(""); 
                    setDoh("");
                    setNik("");
                    setNikAddress("");
                    setNikRel("");
                    setNikContact("");
                    setPosition("");
                    setAccountType("");
                    setEmail("");
                    setGender("");
                    setCompensation("");
                    setName("");
                    setSsn("");
                    setAccNo("");
                    
                    setSuccessMsg(true)
                    setMsg(data.msg)
                    
                    // handleAuthForm()
                  }else{
                  
                    setLoading(false);
                    setMsg(data.msg)
                    setErrorMsg(true);
                  }
            }


            const handleFilter = (event) =>{ 
                console.log(event.target.value);
                const searchWord = event.target.value;
                const newFilter = searchData.filter((value)=>{
                    console.log("searchWord",searchWord)
                     return value.name.toLowerCase().includes(searchWord.toLowerCase());
                      
                })
    
                setFildata(newFilter);
           }
    
    //         async function populateData(){  
    
    //             // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
    //             const response = await fetch("https://nerdayb.onrender.com/api/Alltransactions",{
    //                 headers : { 
    //                 //   'x-access-token' : auth.user,
    //                 }
             
    //             })
                
    //             const data = await response.json();
    //             console.log("All Data here",data.propdata)
    //             if(data){
    
    //         if(data.status == "ok") {
    //             setTData(data.propdata)
    //             setSearchData(data.propdata)
    //             console.log("Data here",data)
    //             }else{
    //             //    alert(data.error,"Here!")
    //             console.log("testign first")
    //             } 
    
    //         }
            
    //         return data;
            
    //   } 
    
    //   useEffect(()=>{ 
    
    //      populateData();
    //      console.log("test populate");
    
    //   },[]) 

            useEffect(() => {
                let isMounted = true;
                const controller = new AbortController();
        
                const getUsers = async () => {
                    try {
                        const response = await axiosPrivate.get('/users', {
                            signal: controller.signal,
                            params: {
                
                                Org: auth.foundUser.Org,
                                // org: 'value2',
                                // mgtLvl: 'value2',
                             
                              }
                        });
                        console.log(response.data);
                        console.log("Heresummary");
                        isMounted && setUsers(response.data);
                        setTData(response?.data)
                        setSearchData(response?.data)
                    } catch (err) {
                        console.error(err);
                    //   navigate('/login', { state: { from: location }, replace: true });
                    }
                }
                console.log("contect",auth)
                getUsers();
        
                return () => {
                    isMounted = false;
                    controller.abort();
                }
            }, [])

    
       const handleSelected = (item) =>{
        
                // console.log("herezz",item)
                setUserData(item)

                // console.log("User",userData)

                // name,
                // email,
                // Gender,
                     const newDate = new Date()
                    //  const newDate = new Date(item?.Hire_Date)
                    const defaultDate = new Date()
                    // const defaultDate = new Date(item?.Hire_Date)?.toISOString().slice(0, 10);
                    setName(item?.name);
                    setEmail(item?.email);
                    setGender(item?.Gender);
                    setPosition(item?.Position);
                    setAccNo(item?.AccountNo);
                    setSelectedtwo(item?.Gender);
                    setMgtLevl(2);
                    setSelected(item?.status)
                    setAddress("");
                    setCompensation(item?.Base_Pay);
                    setSsn(item?.Ssn);
                    setEmail(item.email);
                    setAccountBranch(item?.AccountBranch);
                    setAddress(item?.Home_address);
                    setFInstitutionn(item?.FInstitution); 
                    setDoh(item?.Hire_Date);
                    setNik(item?.NextofKin);
                    setNikAddress(item?.NextofKinAddress);
                    setNikRel(item?.NextofKinRel);
                    setNikContact(item?.NextofKinContact);
                    setAccountType(item?.AccountType);
                    setDoh(defaultDate);
                    setID(item?._id)
                
               
    
       }


       const handleSelect = () =>{ 
         
        setDropState(!dropState); 
    }

       const handleSelecttwo = () =>{ 
         
        console.log("Test here")
        setDropStateTwo(!dropStateTwo); 
    }
            
      


    return <>
    <div className="UserMgtCover">
           
             <div>  
                 <div className="userSearch">   

                   <div className="userHeading">

                    <h2>User Management</h2>

                </div>    
                              {/* input field */}
            <div className='searchBar'>  
          
                    <div className='searchInputs'>
                        <input type="text" name='Locat' onChange = {handleFilter} />
                        <div className='ssearchIcon'> <i class="fa-solid fa-magnifying-glass"></i></div>

                        { 
                        fildata.length > 0 && 
                        (

                        <div className='dataResults'>
                        {
                        searchData && 
                        
                        fildata.map((index,key)=>{
                            
                            return (
                            <div onClick={()=>handleSelected(index)} ><a key={key} className='datItem'>{index.name}</a></div>
                            
                            )
                        
                        })} 
                    
                    </div>


                        )
                    }

                    </div>
                    </div>


                 </div>
                 <div className="UserEditCover">

                            <>

                                <br/>
                                <h3>User Update</h3>
                                    <form onSubmit={registerUser}>
                                        {/* Name */}
                                        <div className="txt_field">
                                        <input
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>Name</label>

                                        </div>
                                        {/* SSN */}
                                        <div className="txt_field">
                                        <input
                                            value={Ssn}
                                            onChange={(e) => setSsn(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>NRC</label>

                                        </div>

                                        {/* Email */}
                                        <div className="txt_field">
                                        <input
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            type="email"
                                            // required
                                        />
                                        <span></span>
                                        <label>Email</label>

                                        </div>
                                        {/* AccountNumber */}
                                        <div className="txt_field">
                                        <input
                                            value={AccNo}
                                            onChange={(e) => setAccNo(e.target.value)}
                                            type="number"
                                            required
                                            // disabled
                                            min={1}
                                            
                                        />
                                        <span></span>
                                        <label>Account Number</label>

                                        </div>

                                        {/* Gender */}
                                        {/* <div className="txt_field">
                                        <input
                                            value={Gender}
                                            onChange={(e) => setGender(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>Gender</label>

                                        </div> */}
                                        {/* Gender */}
                                         {/* Dropdown */}
                              <div className="CInputs">
                                    <label>Gender</label>
                                        
                                        <div className='inputGroupa'>  

                                            {/* TRANSACTION INPUT FIELDS*/}

                                            <div className='dropContainer'>

                                        

                                        
                                                    <div className='categoryButton'  onClick={handleSelecttwo} >

                                                        <div> <p>{selectedtwo}</p> </div>  
                                                        <div> <FontAwesomeIcon icon={faChevronDown} className="FontAwesomeIcon"/></div>

                                                    </div>
                                                        
                                                    { dropStateTwo && <div className='dropDownList'>      
                                                                                                            
                                                                                        
                                                                        { optionstwo.map((item,key)=>{
                                                                        
                                                                            return(
                                                                                    <div  name="Industry" 
                                                                                                        // onChange={handleChange} 
                                                                                                        value={selectedtwo} onClick={e => {
                                                                                                        setSelectedtwo(item);
                                                                                                        setGender(item)
                                                                                                        setType(item);
                                                                                                        setDropStateTwo(false);
                                                                                                        console.log("select",setSelectedtwo)
                                                                                                    
                                                                                
                                                                                    }}
                                                                                
                                                                                
                                                                                
                                                                                key={item} className='dropDownItem'>
                                                                                    <p>{item}</p>
                                                                                </div>
                                                                            )})        

                                                                            }

                                                                </div>                                                                                                                        

                                                        }
                                                

                                    

                                            </div>

                                        </div>
                                    

                                    </div>
                                        {/* <div className="txt_field">
                                        <input
                                            value={position}
                                            onChange={(e) => setPosition(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>Position</label>

                                        </div> */}
                                        {/* Gender */}
                                        <div className="txt_field">
                                        <input
                                            value={mgtLvl}
                                            onChange={(e) => setMgtLevl(e.target.value)}
                                            type="number"
                                            // required
                                            min={1}
                                        />
                                        <span></span>
                                        <label>Mgt Level</label>

                                        </div>
                                        {/* Gender */}
                                        <div className="txt_field">
                                        <input
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>Address</label>

                                        </div>
                                        {/* Compensation */}
                                        <div  className="txt_field">

                                                <input
                                                        value={Compensation}
                                                        onChange={(e) => setCompensation(e.target.value)}
                                                        type="number"
                                                        // placeholder="Password"
                                                        required
                                                        min={1}
                                                    />

                                                <span></span>
                                                <label>Compensation</label>

                                        </div>

                                        {/* ddddd */}
                                          {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={position}
                                            onChange={(e) => setPosition(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Position</label>

                            </div>
                            {/* Compensation */}
                            {/* <div  className="txt_field">

                                    <input
                                            value={Compensation}
                                            onChange={(e) => setCompensation(e.target.value)}
                                            type="number"
                                            // placeholder="Password"
                                            required
                                            min={1}
                                        />

                                    <span></span>
                                    <label>Compensation</label>

                            </div> */}
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Address</label>

                            </div>
                            {/* Compensation */}
                            {/* <div  className="txt_field">

                                    <input
                                            value={doh}
                                            onChange={(e) => setDoh(e.target.value)}
                                            type="date"
                                            // placeholder="Password"
                                            required
                                          
                                        />

                                    <span></span>
                                    <label>Date of Hire</label>

                            </div> */}
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={FInstitution}
                                            onChange={(e) => setFInstitutionn(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Financial Institution</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={AccountType}
                                            onChange={(e) => setAccountType(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Account Type</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={AccountBranch}
                                            onChange={(e) => setAccountBranch(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Account Branch</label>

                            </div>

                            {/* Dropdown Data */}
                             {/* Dropdown */}
                             <div className="CInputs">
                                    <label>Work Status</label>
                                        
                                        <div className='inputGroupa'>  

                                            {/* TRANSACTION INPUT FIELDS*/}

                                            <div className='dropContainer'>

                                        

                                        
                                                    <div className='categoryButton'  onClick={handleSelect} >

                                                        <div> <p>{selected}</p> </div>  
                                                        <div> <FontAwesomeIcon icon={faChevronDown} className="FontAwesomeIcon"/></div>

                                                    </div>
                                                        
                                                    { dropState && <div className='dropDownList'>      
                                                                                                            
                                                                                        
                                                                        { options.map((item,key)=>{
                                                                        
                                                                            return(
                                                                                    <div  name="Industry" 
                                                                                                        // onChange={handleChange} 
                                                                                                        value={selected} onClick={e => {
                                                                                                        setSelected(item);
                                                                                                        setStatus(item)
                                                                                                        // setGender(item)
                                                                                                        setType(item);
                                                                                                        setDropState(false);
                                                                                                        console.log("select",selected)
                                                                                                    
                                                                                
                                                                                    }}
                                                                                
                                                                                
                                                                                
                                                                                key={item} className='dropDownItem'>
                                                                                    <p>{item}</p>
                                                                                </div>
                                                                            )})        

                                                                            }

                                                                </div>                                                                                                                        

                                                        }
                                                

                                    

                                            </div>

                                        </div>
                                    

                                    </div>



                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nik}
                                            onChange={(e) => setNik(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin (NIK) Name</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikRel}
                                            onChange={(e) => setNikRel(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Relationship</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikAddress}
                                            onChange={(e) => setNikAddress(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Address</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikContact}
                                            onChange={(e) => setNikContact(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Contact</label>

                            </div>

                             

                                        
                                        {Loading ?<div>
                                        
                                            <BeatLoader color="#36d7b7" />
                                        </div> :    
                                        <>
                                        <input type="submit" value="Update Details" />
                                    
                                            
                                            {successMsg && <div className="successMsgContainer">
                                                        
                                                        <p>{`Operation successfull! ${Msg}`}</p>
                                                        
                                            </div>}
                                            {errorMsg && <div className="errorMsgContainer">
                                                        
                                                        <p>{`Operation Failed! ${Msg}`}</p>
                                                        
                                            </div>}

                                            
                                        
                                        </>
                                        }
                                            
                                        
                                        
                                    </form>
                                <br/>
                                <br/>
                            </>

                 </div>

             </div>
             
      
               
        </div>
        
    </>

}

export default EditUser;

// Job Details
// Name

// Employee ID

// Position

// Gender

// Account_N0

// Base_Pay

// Management Level

// Level 1
// Employee Type

// Location

// Original Hire Date

// Contact Information - Public
// Social Security Number

// Email

// Phone Number

// Home Address